import React from 'react';

function TriangleIcon({ direction, type, className, onClick }) {
  return (
    <div
      className={`triangle-icon triangle-icon__${direction} triangle-icon__${type} ${className || ''}`}
      onClick={onClick}
    />
  );
}

export default TriangleIcon;
